import React, { useEffect, useState } from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
  PDFDownloadLink,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'
import { useParams } from 'react-router-dom'
import { getData } from '../../../api/indexedDBHandler'
import Button from '@mui/material/Button'
Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 15,
    fontFamily: 'Roboto',
    fontSize: 10,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  tournamentInfo: {
    width: '100%',
  },
  logo: {
    width: 80,
    height: 'auto',
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 5,
    textTransform: 'uppercase',
  },
  infoRow: {
    flexDirection: 'row',
    marginBottom: 2,
  },
  infoLabel: {
    width: 100,
    fontWeight: 'bold',
  },
  teamHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  teamName: {
    fontSize: 11,
    fontWeight: 'bold',
  },
  teamMembers: {
    fontSize: 9,
  },
  sectorBadge: {
    backgroundColor: 'black',
    width: 36,
    height: 36,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectorNumber: {
    color: 'white',
    fontSize: 22,
    fontWeight: 'bold',
  },
  tableHeader: {
    backgroundColor: '#f2f2f2',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000',
  },
  tableHeaderCell: {
    paddingVertical: 3,
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
    borderRightWidth: 1,
    borderColor: '#000',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderColor: '#000',
    minHeight: 20,
  },
  tableCell: {
    paddingVertical: 2,
    fontSize: 9,
    borderRightWidth: 0.5,
    borderColor: '#000',
  },
  numberCell: {
    width: '5%',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  sponsorsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: 15,
    gap: 10,
  },
  sponsorLogo: {
    height: 30,
    width: 'auto',
    maxWidth: 100,
  },
})
const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '400px',
    maxWidth: '90%',
  },
  inputGroup: { marginBottom: '15px' },
  numberInput: { marginLeft: '10px', padding: '5px' },
  select: { marginLeft: '10px', padding: '5px', width: '100%' },
  buttonGroup: { display: 'flex', justifyContent: 'flex-end', gap: '10px' },
  cancelButton: { padding: '8px 16px', backgroundColor: '#f0f0f0' },
  generateButton: { padding: '8px 16px', color: 'white' },
}
const Modal = ({ teams = [], onSelect, onClose }) => {
  const [startNumber, setStartNumber] = useState(1)
  const [selectedTeamId, setSelectedTeamId] = useState('')

  const selectedTeam =
    teams.find((team) => Number(team?.team?.id) === Number(selectedTeamId)) ||
    null

  const handleSubmit = (e) => {
    e.preventDefault()
    // console.log('Submit Clicked')

    // console.log('Teams:', teams) // Проверяем, загружаются ли команды
    // console.log('Selected Team ID:', selectedTeamId) // Проверяем ID
    // console.log('Found Team:', selectedTeam) // Проверяем, найдена ли команда

    if (!selectedTeam) {
      //   console.log('No team selected')
      alert('Пожалуйста, выберите команду')
      return
    }

    //  console.log('Selected Team:', selectedTeam)
    onSelect(startNumber, selectedTeam)
  }

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.content}>
        <h3>Выберите параметры протокола</h3>

        <form onSubmit={handleSubmit}>
          <div style={modalStyles.inputGroup}>
            <label>Начальный номер в таблице (1, 31, 61, 91 ...):</label>
            <input
              type="number"
              min="1"
              value={startNumber}
              onChange={(e) =>
                setStartNumber(Math.max(1, parseInt(e.target.value) || 1))
              }
              style={modalStyles.numberInput}
              required
            />
          </div>

          <div style={modalStyles.inputGroup}>
            <label>Выберите команду:</label>
            <select
              value={selectedTeamId}
              onChange={(e) => {
                setSelectedTeamId(e.target.value)
                //   console.log('Selected Team ID:', e.target.value)
              }}
              style={modalStyles.select}
              required
            >
              <option value="">-- Выберите команду --</option>
              {teams
                .filter((t) => t?.team?.id)
                .map((team) => (
                  <option key={team.team.id} value={team.team.id}>
                    {team.team.team_name_ru || `Команда ${team.team.id}`}
                  </option>
                ))}
            </select>
          </div>

          <div style={modalStyles.buttonGroup}>
            <button
              type="button"
              onClick={onClose}
              style={modalStyles.cancelButton}
            >
              Отмена
            </button>
            <button
              type="submit"
              disabled={!selectedTeamId}
              style={{
                ...modalStyles.generateButton,
                backgroundColor: selectedTeamId ? '#4CAF50' : '#cccccc',
              }}
            >
              Сгенерировать
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
const TournamentProtocolDrawPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
}) => {
  const name = (teamData) => {
    if (tournament.competition_type == 'Рейтинговое соревнование')
      return teamData?.team_name_ru
    return teamData?.preferred_name == 'en'
      ? teamData?.team_name_en
        ? teamData?.team_name_en
        : teamData?.team_name_ru
      : teamData?.team_name_ru
  }
  // console.log('vvvvvvvvv', data)
  const getname = name(data?.selectedTeam.team)

  const sp1sports_category = data?.selectedTeam.athlete[0]?.sports_category
    ? ' (' + data?.selectedTeam.athlete[0]?.sports_category + ')'
    : ''
  const sp1 = data?.selectedTeam.athlete[0]?.fio
    ? data?.selectedTeam.athlete[0]?.fio
    : ''

  const sp2sports_category = data?.selectedTeam.athlete[1]?.sports_category
    ? ' (' + data?.selectedTeam.athlete[1]?.sports_category + ')'
    : ''
  const sp2 = data?.selectedTeam.athlete[1]?.fio
    ? ', ' + data?.selectedTeam.athlete[1]?.fio
    : ''

  const sp3sports_category = data?.selectedTeam.athlete[2]?.sports_category
    ? ' (' + data?.selectedTeam.athlete[2]?.sports_category + ')'
    : ''
  const sp3 = data?.selectedTeam.athlete[2]?.fio
    ? ', ' + data?.selectedTeam.athlete[2]?.fio
    : ''

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap={false}>
        {/* Заголовок турнира */}
        <View style={styles.header}>
          <View style={styles.tournamentInfo}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Водоём:</Text>
              <Text>{tournament.water_body}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Дата проведения:</Text>
              <Text>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </View>
          </View>
        </View>

        {/* Информация о команде */}
        <View style={styles.teamHeader}>
          <View>
            <Text style={styles.teamName}>{getname}</Text>
            <Text style={styles.teamMembers}>
              {sp1 +
                sp1sports_category +
                sp2 +
                sp2sports_category +
                sp3 +
                sp3sports_category}
            </Text>
          </View>
          <View style={styles.sectorBadge}>
            <Text style={styles.sectorNumber}>
              {data?.selectedTeam.team.sector}
            </Text>
          </View>
        </View>

        {/* Название протокола */}
        <Text style={[styles.title, { fontSize: 12, marginBottom: 8 }]}>
          Протокол результатов взвешивания соревнований
        </Text>

        {/* Таблица */}
        <View>
          {/* Шапка таблицы */}
          <View style={styles.tableHeader}>
            <Text style={[styles.tableHeaderCell, { width: '5%' }]}>№</Text>
            <Text style={[styles.tableHeaderCell, { width: '15%' }]}>
              Вес рыбы
            </Text>
            <Text style={[styles.tableHeaderCell, { width: '5%' }]}>Вид</Text>
            <Text style={[styles.tableHeaderCell, { width: '10%' }]}>Дата</Text>
            <Text style={[styles.tableHeaderCell, { width: '10%' }]}>
              Время
            </Text>
            <Text style={[styles.tableHeaderCell, { width: '25%' }]}>
              Подпись участника
            </Text>
            <Text
              style={[
                styles.tableHeaderCell,
                { width: '30%', borderRightWidth: 0 },
              ]}
            >
              ФИО и подпись судьи
            </Text>
          </View>

          {/* Строки таблицы */}
          {Array.from({ length: 30 }).map((_, index) => (
            <View key={index} style={styles.tableRow}>
              <View style={[styles.tableCell, styles.numberCell]}>
                <Text>{data?.startNumber + index}</Text>
              </View>
              <View style={[styles.tableCell, { width: '15%' }]} />
              <View style={[styles.tableCell, { width: '5%' }]} />
              <View style={[styles.tableCell, { width: '10%' }]} />
              <View style={[styles.tableCell, { width: '10%' }]} />
              <View style={[styles.tableCell, { width: '25%' }]} />
              <View style={{ width: '30%' }} />
            </View>
          ))}
        </View>

        {/* Логотипы спонсоров */}
        {allLogo.length > 0 && (
          <View style={styles.sponsorsContainer}>
            {allLogo.map((item, index) => (
              <Image key={index} src={item.url} style={styles.sponsorLogo} />
            ))}
          </View>
        )}
      </Page>
    </Document>
  )
}
const ProtocolSector = () => {
  const [showPdfLink, setShowPdfLink] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [stage, setStage] = useState(null)
  const [tournament, setTournament] = useState(null)
  const [allLogos, setAllLogos] = useState([])
  const [administrator, setAdministrator] = useState([])
  const [protocolParams, setProtocolParams] = useState({
    startNumber: 1,
    selectedTeam: null,
  })
  const { id } = useParams()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resultsS = await getData('teams', 'id', id)
        if (resultsS.length > 0) {
          const { value } = resultsS[0]
          const teamsArray = Object.values(value)

          const filteredTeams = teamsArray.filter((teamEntry) => {
            const isValidTeam =
              teamEntry !== null &&
              typeof teamEntry === 'object' &&
              teamEntry.team?.status === 'Заявка одобрена' &&
              teamEntry.team?.status_location === 1
            return isValidTeam
          })

          setStage(Object.values(filteredTeams) || [])
        }

        const resultsT = await getData('tournaments', 'id', id)
        if (resultsT.length > 0) {
          const { value } = resultsT[0]
          setTournament(value)
          setAllLogos(Object.values(value.sponsor))
          setAdministrator(Object.values(value.administrator))
        }
      } catch (error) {
        console.error('Ошибка при загрузке данных:', error)
      }
    }

    if (showModal || showPdfLink) {
      fetchData()
    }
  }, [showModal, showPdfLink, id])

  const handleGenerate = (startNumber, selectedTeam) => {
    // console.log('Generating PDF for:', selectedTeam)

    if (!selectedTeam) {
      alert('Пожалуйста, выберите команду')
      return
    }

    setProtocolParams({ startNumber, selectedTeam })
    setShowModal(false)
    setShowPdfLink(true)
  }

  return (
    <div>
      <Button
        variant="contained"
        size="small"
        onClick={() => setShowModal(true)}
        sx={{ mt: 1 }}
      >
        Выбрать сектор
      </Button>

      {showModal && stage && (
        <Modal
          teams={stage}
          onSelect={handleGenerate}
          onClose={() => setShowModal(false)}
        />
      )}

      {showPdfLink && tournament && protocolParams.selectedTeam && (
        <PDFDownloadLink
          document={
            <TournamentProtocolDrawPDF
              allLogo={allLogos}
              mainLogo={getLogoUrl(tournament?.logocup)}
              data={protocolParams}
              administrator={administrator}
              tournament={tournament}
              date={dateNowProtocol(new Date())}
              startNumber={protocolParams.startNumber}
            />
          }
          fileName={`протокол сектора ${protocolParams.startNumber}.pdf`}
          onClick={() => setTimeout(() => setShowPdfLink(false), 0)}
        >
          {({ loading }) => (
            <button
              style={{
                padding: '10px 20px',
                backgroundColor: loading ? '#ccc' : '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px',
              }}
              disabled={loading}
            >
              {loading ? 'Генерация PDF...' : 'Скачать'}
            </button>
          )}
        </PDFDownloadLink>
      )}
    </div>
  )
}

export default ProtocolSector
